var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MPInstanceMessagingBFF } from "@/api/RequestAxios/RequestAxiosMessagingBFF";
import config from "@/config";
import { unpackPartnerSafeMode, unpackWabaStates } from "./messaging.mapper";
// The endpoint caps `limit` at 100.
export var MAX_PAGE_SIZE = 300;
// Backstop so a wrong total_count can never spin the loop.
export var MAX_PAGES = 10;
// The BFF has no path prefix and no /v1 - paths start at the root.
var partnerSafeModeURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partner/".concat(partnerId, "/safe_mode");
};
var partnerWabaStatesURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partner/".concat(partnerId);
};
/**
 * Production has no BFF URL issued yet. With an empty baseURL axios would fall
 * back to same-origin relative requests against the Hub, so every caller must
 * gate on this rather than relying on the request simply failing.
 */
export var isMessagingBffConfigured = Boolean(config.messagingBffUrl);
/** GET /partner/{partner_id}/safe_mode */
export var getPartnerSafeMode = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceMessagingBFF.buffedInstances.get(partnerSafeModeURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerSafeMode(data)];
            }
        });
    });
};
/**
 * POST /partner/{partner_id}/safe_mode
 *
 * One endpoint serves both directions - there is no separate disable call.
 * The response carries the authoritative new value, so callers can set state
 * straight from it without a refetch.
 */
export var setPartnerSafeMode = function (_a, _b) {
    var partnerId = _a.partnerId;
    var enabled = _b.enabled;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, MPInstanceMessagingBFF.buffedInstances.post(partnerSafeModeURL({ partnerId: partnerId }), { enabled: enabled })];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, unpackPartnerSafeMode(data)];
            }
        });
    });
};
/** GET /partner/{partner_id} - one page of WABA states. */
export var getPartnerWabaStates = function (_a, _b) {
    var partnerId = _a.partnerId;
    var _c = _b === void 0 ? {} : _b, _d = _c.offset, offset = _d === void 0 ? 0 : _d, _e = _c.limit, limit = _e === void 0 ? MAX_PAGE_SIZE : _e;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, MPInstanceMessagingBFF.buffedInstances.get(partnerWabaStatesURL({ partnerId: partnerId }), { params: { offset: offset, limit: limit } })];
                case 1:
                    data = (_f.sent()).data;
                    return [2 /*return*/, {
                            states: unpackWabaStates(data),
                            totalCount: typeof (data === null || data === void 0 ? void 0 : data.total_count) === "number" ? data.total_count : 0
                        }];
            }
        });
    });
};
/**
 * Every WABA state for a partner.
 *
 * Deliberately paginates GET /partner/{id} rather than calling the single-WABA
 * endpoint once per WABA: a 50-row channels list must produce ONE request, not
 * 50. Typical partners fit in a single page.
 */
export var getAllPartnerWabaStates = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var collected, page, _b, states, totalCount;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    collected = [];
                    page = 0;
                    _c.label = 1;
                case 1:
                    if (!(page < MAX_PAGES)) return [3 /*break*/, 4];
                    return [4 /*yield*/, getPartnerWabaStates({ partnerId: partnerId }, { offset: page * MAX_PAGE_SIZE, limit: MAX_PAGE_SIZE })];
                case 2:
                    _b = _c.sent(), states = _b.states, totalCount = _b.totalCount;
                    collected.push.apply(collected, __spreadArray([], __read(states), false));
                    // Stop on a short/empty page too, so a bad total_count cannot keep us going.
                    if (states.length === 0 || collected.length >= totalCount)
                        return [2 /*return*/, collected];
                    if (page === MAX_PAGES - 1) {
                        console.warn("[messaging] Stopped paginating partner ".concat(partnerId, " WABA states at ").concat(collected.length, " of ").concat(totalCount, "."));
                    }
                    _c.label = 3;
                case 3:
                    page++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, collected];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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